
import {Injectable} from "@angular/core";
import dayjs from "dayjs";
import { IMapperSisben } from "../interface/mapperSisben";
import { INucleoFamiliar } from "../interface/sisben";

@Injectable()
class MapperModificarSisben implements IMapperSisben<any, INucleoFamiliar> {

  fromDtoToEntity(dto: INucleoFamiliar): any {
    return {
      page1: {
        nombreCompleto : dto.nombreCompleto,
        tipoIdentificacion : dto.tipoIdentificacion,
        identificacion: dto.identificacion,
        vinculo: dto.vinculoDescripcion
      }
    }
  }
}

@Injectable()
class MapperRetiroSisben implements IMapperSisben<any, INucleoFamiliar> {
  fromDtoToEntity(value: INucleoFamiliar): any {
    return  {
      page1: {
        nombreCompleto : value.nombreCompleto,
        tipoIdentificacion : value.tipoIdentificacion,
        identificacion: value.identificacion,
        vinculo: value.vinculoDescripcion
      }
    }
  }

}


export {
  MapperModificarSisben,
  MapperRetiroSisben
}
